// extracted by mini-css-extract-plugin
export default {"baseButton":"style_baseButton__fCntd","baseButtonSelected":"style_baseButtonSelected__1COWH"};